import { CreatePollInput } from '../../content.js';
import { PollView, VoteInput } from '../../civic.js';
export const pollRoutes = {
    create: { method: 'POST', path: '/polls', body: CreatePollInput, response: PollView },
    get: { method: 'GET', path: '/polls/:pollId', response: PollView },
    vote: { method: 'POST', path: '/polls/:pollId/votes', body: VoteInput, response: PollView },
};
//# sourceMappingURL=routes.js.map